import { useEffect, useRef, useState } from "react";
import BriefcaseIconWithColor from "../../assets/images/BriefcaseIconWithColor";
import EditIconWithColor from "../../assets/images/EditIconWithColor";
import { Constants, OnboardConstants } from "../../constants/constants";
import EducationalDetailsTable from "./EducationalDetailsTable";
import RolesAndPermissionTable from "./RolesAndPermissionTable";
import { TextFeild } from "./TextFeild";
import WorkExperienceTable from "./WorkExperienceTable";
import PersonalInformationDynamic from "./PersonalInformationDynamic";
import RolesAndPermissionIconWithColor from "../../assets/images/RolesAndPermissionIconWithColor";
import BranchesIcon from "../../assets/images/BranchesIcon";
import { MobileResponsiveUserDetail } from "./MobileResponsiveUserDetail";
import { maskBankValue } from "../../utils/validationUtils";
export function getButtonLabel(showSave: boolean, data: any): string {
  if (showSave) return "Save";
  if (data?.value?.length > 0) return "Edit";
  return "Add more";
}
export function getButtonName(showSave: boolean): string {
  if (showSave) return "Save";
  return "Add more";
}
export interface Attribute {
  attributeId: number;
  name: string;
  label: string;
  inputType: string;
  attributeOrder: number;
  isRequired: boolean;
  options?: any;
  apiUrl?: string;
  dependsOn?: string | null;
  validationRules?: any[];
  value?: any;
}

export interface SubSegment {
  subSegmentId: number;
  name: string;
  description: string;
  canMultiple: boolean;
  subSegmentOrder: number;
  attributes: Attribute[];
}

export const DynamicUserDetail: React.FC<{
  jsonObj: any;
  order: number;
  setEditPayloadjson: any;
  jsonForEditData: any;
  setEditMode: any;
  // addMoreRoles: any;
  isEditMode: any;
  handleSaveButton: any;
  handleCancelButton: any;
  isSaveButtonCLicked: any;
  setIsSaveButtonClicked?: any;
  errors?: any;
  setShowSaveRolesButton: any;
  setShowSaveWorkButton: any;
  setShowSaveEducationButton: any;
  showSaveRolesButton: any;
  showSaveWorkButton: any;
  showSaveEducationButton: any;
  setEditModeForEducationalDetails: any;
  editModeForEducationalDetails: any;
  setEditModeForWorkDetails: any;
  editModeForWorkDetails: any;
  setErrors: any;
  isApiSucessfull?:any;
  setSaveWithDeletedRoles?:any;
  saveEditUserDetails?:any;
  saveWithDeletedRoles?:any;
  setIsErrors?:any;
  setSelectedSpecializationList?:any;
  selectedSpecializationList?:any;
}> = ({
  jsonObj: updatedJsonObj,
  order,
  setEditPayloadjson,
  jsonForEditData,
  setEditMode,
  // addMoreRoles,
  isEditMode,
  handleSaveButton,
  handleCancelButton,
  isSaveButtonCLicked,
  setIsSaveButtonClicked,
  errors,
  setShowSaveRolesButton,
  setShowSaveWorkButton,
  setShowSaveEducationButton,
  showSaveRolesButton,
  showSaveWorkButton,
  showSaveEducationButton,
  setEditModeForEducationalDetails,
  editModeForEducationalDetails,
  setEditModeForWorkDetails,
  editModeForWorkDetails,
  setErrors,
  isApiSucessfull,
  setSaveWithDeletedRoles,
  saveEditUserDetails,
  saveWithDeletedRoles,
  setIsErrors,
  setSelectedSpecializationList,
  selectedSpecializationList,
}) => {
  const [addMoreRoles, setAddMoreRoles] = useState(false);

  const [editModeForRolesDetails, setEditModeForRolesDetails] = useState(false);
  const [educationalDetailsIndex, setEducationalDetailsIndex] = useState(0);
  const [showEducationTableInEditFlow, setShowEducationTableInEditFlow] =
    useState(false);
  const [showWorkTableInEditFlow, setShowWorkTableInEditFlow] = useState(false);
  const [showRolesTableInEditFlow, setShowRolesTableInEditFlow] =
    useState(false);
  const [workDetailsIndex, setWorkDetailsIndex] = useState(0);
  const [rolesDetailsIndex, setRolesDetailsIndex] = useState(0);
  const [rolesDetailsIndexForValidation, setRolesDetailsIndexForValidation] =
    useState<number | null>(null);
  const [workDetailsIndexForValidation, setWorkDetailsIndexForValidation] =
    useState<number | null>(null);
  const [
    educationalDetailsIndexForValidation,
    setEducationalDetailsIndexForValidation,
  ] = useState<number | null>(null);
  const educationalIndexRef = useRef<number | null>(0);
  const workDetailsIndexRef = useRef<number | null>(0);
  const [isWorkDetailsNull,setIsWorkDetailsNull] = useState(false);



  const handleEditEducationalInformation = (index: any) => {
    setEditModeForEducationalDetails(true);
    setShowEducationTableInEditFlow(true);
    setShowSaveEducationButton(true);
    setEducationalDetailsIndex(index);
    educationalIndexRef.current = index;
    setEducationalDetailsIndexForValidation(index);
  };

  const handleEditWorkInformation = (index: any) => {
    setEditModeForWorkDetails(true);
    setShowWorkTableInEditFlow(true);
    setWorkDetailsIndex(index);
    setShowSaveWorkButton(true);
    workDetailsIndexRef.current = index;
    setWorkDetailsIndexForValidation(index);
  };

  const [addMoreEducationalInfo, setAddMoreEducationalInfo] = useState(false);
  const addMoreEducationEditRef = useRef(false);
  const addMoreWorkEditRef = useRef(false);
  const handelAddmoreEditEducationalDetails = () => {
    addMoreEducationEditRef.current = true;
    setEditModeForEducationalDetails(true);
    setAddMoreEducationalInfo(true);
    setShowSaveEducationButton(true);
  };
  const [addMoreWorkInfo, setAddMoreWorkInfo] = useState(false);
  const handelAddmoreEditWorkDetails = () => {
    if(isWorkDetailsNull){
      setEditModeForWorkDetails(true);
    setShowWorkTableInEditFlow(true);
    setWorkDetailsIndex(0);
    setShowSaveWorkButton(true);
    workDetailsIndexRef.current = 0;
    setWorkDetailsIndexForValidation(0);
    }else{
    addMoreWorkEditRef.current = true;
    setEditModeForWorkDetails(true);
    setAddMoreWorkInfo(true);
    setShowSaveWorkButton(true);
    }
  };
  const [addMoreRolesInfo, setAddMoreRolesInfo] = useState(false);
  const [showSaveTrainingButton, setShowSaveTrainingButton] = useState(false);
  const [showSaveBranchesButton, setShowSaveBranchesButton] = useState(false);
  const handelAddmoreEditRolesDetails = () => {
    setAddMoreRoles(true);
    setEditModeForRolesDetails(true);
    setAddMoreRolesInfo(true);
    setShowSaveRolesButton(true);
  };

  const [key, setKey] = useState(0);
  const [
    EditModeForTrainingCertification,
    setEditModeForTrainingCertification,
  ] = useState(false);
  const [
    EditModeForBranchesCertification,
    setEditModeForBranchesCertification,
  ] = useState(false);
  const handelEditTrainingCertification = () => {
    setEditModeForTrainingCertification(true);
    setShowSaveTrainingButton(true);
  };

  const handelEditBranchesCertification = () => {
    setEditModeForBranchesCertification(true);
    setShowSaveBranchesButton(true);
  };

  const trainingInfo = updatedJsonObj[order]?.subSegments.filter(
    (item: { name: string }) => item.name === "Training & Certifications"
  );

  const BranchesInfo = updatedJsonObj[order]?.subSegments.filter(
    (item: { name: string }) => item.name === "Branches"
  );

  const trainingForedit = () => {
    return {
      segmentId: updatedJsonObj[order]?.segmentId,
      name: updatedJsonObj[order]?.name,
      description: updatedJsonObj[order]?.description,
      segmentOrder: updatedJsonObj[order]?.segmentOrder,
      subSegments: trainingInfo,
    };
  };
  const branchesForedit = () => {
    return {
      segmentId: updatedJsonObj[order]?.segmentId,
      name: updatedJsonObj[order]?.name,
      description: updatedJsonObj[order]?.description,
      segmentOrder: updatedJsonObj[order]?.segmentOrder,
      subSegments: BranchesInfo,
    };
  };
  let jsonForTrainingCertification = trainingForedit();
  let jsonForBranchesCertification = branchesForedit();
  useEffect(() => {
    jsonForTrainingCertification = trainingForedit();
    jsonForBranchesCertification = branchesForedit();
  }, [updatedJsonObj]);

  useEffect(() => {
    if(isApiSucessfull){
      setShowSaveEducationButton(false);
    setEditModeForEducationalDetails(false);
    setShowEducationTableInEditFlow(false);
    setShowSaveWorkButton(false);
    setEditModeForWorkDetails(false);
    setShowWorkTableInEditFlow(false);
    }
  },[isApiSucessfull]);
  const handelSaveEducationalDetails = () => {
    // setShowSaveEducationButton(false);
    // setEditModeForEducationalDetails(false);
    // setShowEducationTableInEditFlow(false);
    handleSaveButton(
      true,
      educationalDetailsIndexForValidation,
      "Educational Information"
    );
    // setShowSaveEducationButton(false);
    // setEditModeForEducationalDetails(false);
    // setShowEducationTableInEditFlow(false);
  };
  const handelSaveWorkDetails = () => {
    if (workDetailsIndexForValidation !== null) {
      const workDetails = jsonForEditData.formSegments[order].subSegments.filter(
        (sub: any) => sub?.name === "Work Experience"
      );
  
      const currentWorkDetails = workDetails[workDetailsIndexForValidation];
      console.log("Current Work Details:", currentWorkDetails);
      if (!currentWorkDetails) return;
  
      // check if ALL attributes are empty/null
      const allEmpty = currentWorkDetails?.attributes?.every(
        (attr: any) =>
          attr.value === null ||
          attr.value === "" ||
          (Array.isArray(attr?.value) && attr?.value?.length === 0)
      );
      console.log("Are all attributes empty?", allEmpty);
      if (allEmpty) {
        // ✅ remove the subsegment
        setEditPayloadjson((prevData: any) => {
          const updatedData = { ...prevData };
        
          updatedData.formSegments[order] = {
            ...updatedData?.formSegments[order],
            subSegments: removeWorkDetailAtIndex(
              updatedData.formSegments[order]?.subSegments,
              workDetailsIndexForValidation
            ),
          };
        
          console.log("Updated SubSegments:", updatedData.formSegments[order].subSegments);
          return updatedData;
        });
        
        
        setShowSaveWorkButton(false);
        setEditModeForWorkDetails(false);
        setShowWorkTableInEditFlow(false);
        handleSaveButton(false, null, "Work Experience");
      }
  
      // ✅ save normally if not empty
      handleSaveButton(true, workDetailsIndexForValidation, "Work Experience");
    } else {
      const workDetails = jsonForEditData.formSegments[order].subSegments.filter(
        (sub: any) => sub?.name === "Work Experience"
      );
  
      const currentWorkDetails = workDetails[workDetails.length - 1];
      console.log("Current Work Details:", currentWorkDetails);
      if (!currentWorkDetails) return;
  
      // check if ALL attributes are empty/null
      const allEmpty = currentWorkDetails?.attributes?.every(
        (attr: any) =>
          attr.value === null ||
          attr.value === "" ||
          (Array.isArray(attr?.value) && attr?.value?.length === 0)
      );
      console.log("Are all attributes empty?", allEmpty);
      if (allEmpty) {
        // ✅ remove the subsegment
        setEditPayloadjson((prevData: any) => {
          const updatedData = { ...prevData };
        
          updatedData.formSegments[order] = {
            ...updatedData?.formSegments[order],
            subSegments: removeWorkDetailAtIndex(
              updatedData.formSegments[order]?.subSegments,
              workDetails.length - 1
            ),
          };
        
          console.log("Updated SubSegments:", updatedData.formSegments[order].subSegments);
          return updatedData;
        });
        
        
        setShowSaveWorkButton(false);
        setEditModeForWorkDetails(false);
        setShowWorkTableInEditFlow(false);
        
      handleSaveButton(true, workDetailsIndexForValidation, "Work Experience");
    }
    else{
      handleSaveButton(true, workDetailsIndexForValidation, "Work Experience");
    }
  }
  };
  


  const removeWorkDetailAtIndex = (
    subSegments: any[],
    workIndex: number
  ): any[] => {
    // Separate work experience and others
    const workSegments = subSegments.filter(s => s.name === "Work Experience");
    const otherSegments = subSegments.filter(s => s.name !== "Work Experience");
  
    // Remove the work segment at the given workIndex
    const updatedWorkSegments = workSegments.filter(
      (_, idx) => idx !== workIndex
    );
  
    // Merge back — preserve original order: education → work → others
    return [
      ...subSegments.filter(s => s.name === "Educational Information"),
      ...updatedWorkSegments,
      ...subSegments.filter(
        s => s.name !== "Educational Information" && s.name !== "Work Experience"
      ),
    ];
  };

  

  const [isSpecilizationManditory, setIsSpecilizationManditory] = useState(false);
  useEffect(() => {
    if(errors?.specializationIds && errors?.length > 0){
      setShowSaveRolesButton(false);

      setEditModeForRolesDetails(false);
      setShowRolesTableInEditFlow(false);
    }
  },[errors]);
  
  const handelSaveRolesDetails = () => {
    if(saveWithDeletedRoles){
      saveEditUserDetails(true);
      // setIsErrors(false);
    }else{
    setShowSaveWorkButton(false);
    setEditModeForWorkDetails(false);
    setShowWorkTableInEditFlow(false);
    handleSaveButton(true, rolesDetailsIndexForValidation, "Roles",isSpecilizationManditory);
    }
  };
  const [isBranchesManditory, setIsBranchesManditory] = useState(false);
  useEffect(() => {
    if(errors?.branches && errors?.branches.length > 0){
    setShowSaveBranchesButton(true);
    setEditModeForRolesDetails(true);
    setShowRolesTableInEditFlow(true);
    }
  },[errors]);
  const handelSaveBranchesDetails = () => {
    setShowSaveBranchesButton(false);
    setEditModeForRolesDetails(false);
    setShowRolesTableInEditFlow(false);
    handleSaveButton(true, rolesDetailsIndexForValidation, "branches",isBranchesManditory);
  };
  const handelSaveTrainingDetails = () => {
    setShowSaveTrainingButton(false);
    setEditModeForTrainingCertification(false);
    handleSaveButton(
      true,
      rolesDetailsIndexForValidation,
      "Training & Certifications"
    );
  };

  const handelCancelEducationalDetails = async () => {
    setShowSaveEducationButton(false);
    setEditModeForEducationalDetails(false);
    setShowEducationTableInEditFlow(false);
    await handleCancelButton();
  };

  const handelCancelButtonForAddMoreEducationDetails = async () => {
    jsonForEditData?.formSegments[order]?.subSegments.pop();
    setShowSaveEducationButton(false);
    setEditModeForEducationalDetails(false);
    setShowEducationTableInEditFlow(false);
   await handleCancelButton();
  };

  const handelCancelWorkDetails = async() => {
    setShowSaveWorkButton(false);
    setEditModeForWorkDetails(false);
    setShowWorkTableInEditFlow(false);
    await handleCancelButton();
  };

  const handelCancelButtonForAddMoreWorkDetails = async() => {
    jsonForEditData?.formSegments[order]?.subSegments.pop();
    setShowSaveWorkButton(false);
    setEditModeForWorkDetails(false);
    setShowWorkTableInEditFlow(false);
    await handleCancelButton();
  };
  const handelCancelBranchesDetails = () => {
    setShowSaveBranchesButton(false);
    setEditModeForRolesDetails(false);
    setShowRolesTableInEditFlow(false);
    handleCancelButton();
  };
  const handelCancelTrainingDetails = () => {
    setShowSaveTrainingButton(false);
    setEditModeForTrainingCertification(false);
    handleCancelButton();
  };
  const handelCancelRolesDetails = () => {
    setAddMoreRolesInfo(false);
    setShowSaveRolesButton(false);
    setAddMoreRoles(false);
    setEditModeForRolesDetails(false);
    setShowRolesTableInEditFlow(false);
    handleCancelButton();
  };
  const handelCancelButtonForAddMoreRolesDetails = () => {
    jsonForEditData?.formSegments[order]?.subSegments.pop();
    setAddMoreRolesInfo(false);
    setShowSaveRolesButton(false);
    setAddMoreRoles(false);
    setEditModeForRolesDetails(false);
    setShowRolesTableInEditFlow(false);
    handleCancelButton();
  };
  const trainingSegment = updatedJsonObj[order]?.subSegments.find(
    (item: { name: string }) => item.name === "Training & Certifications"
  );
  const trainingCertifications = trainingSegment?.attributes.find(
    (attr: { name: string }) => attr.name === "trainingCertifications"
  );
  const branchesSegment = updatedJsonObj[order]?.subSegments.find(
    (item: { name: string }) => item.name === "Branches"
  );
  const branches = branchesSegment?.attributes.find(
    (attr: { name: string }) => attr.name === "branches"
  );


  const isDeletingRef = useRef(false);
  const handleDeleteButtonChangeForEditFlow = (index: number) => {
    const rolesSegments = jsonForEditData?.formSegments[order]?.subSegments?.filter((seg: { name: string; }) => seg.name === "Roles");
    if
    (rolesSegments.length ===1){
    }else{
    setShowSaveRolesButton(true);
      setEditPayloadjson((prevData: any) => {
        const updatedData = { ...prevData };
        if(isDeletingRef.current === true) {
        const subSegments = [...(updatedData.formSegments[order]?.subSegments || [])];
        if (index >= 0 && index < subSegments.length) {
          subSegments.splice(index, 1);
        }
        updatedData.formSegments[order] = {
          ...updatedData.formSegments[order],
          subSegments,
        };
        isDeletingRef.current = false;
      }
        return updatedData;
      });
      setSaveWithDeletedRoles(true);
    }
  };
  return (
    <>
      <div className="block lg:hidden">
        <MobileResponsiveUserDetail
          jsonObj={updatedJsonObj}
          order={order}
          setEditPayloadjson={setEditPayloadjson}
          jsonForEditData={jsonForEditData}
          handleSaveButton={handleSaveButton}
          handleCancelButton={handleCancelButton}
          handelAddmoreEditEducationalDetails={
            handelAddmoreEditEducationalDetails
          }
          handelAddmoreEditWorkDetails={handelAddmoreEditWorkDetails}
          handelAddmoreEditRolesDetails={handelAddmoreEditRolesDetails}
          handelSaveEducationalDetails={handelSaveEducationalDetails}
          handelSaveWorkDetails={handelSaveWorkDetails}
          handelSaveBranchesDetails={handelSaveBranchesDetails}
          handelSaveTrainingDetails={handelSaveTrainingDetails}
          handelSaveRolesDetails={handelSaveRolesDetails}
          handelCancelEducationalDetails={handelCancelEducationalDetails}
          updatedJsonObj={updatedJsonObj}
          handelCancelWorkDetails={handelCancelWorkDetails}
          handelCancelBranchesDetails={handelCancelBranchesDetails}
          workDetailsIndex={workDetailsIndex}
          educationalDetailsIndex={educationalDetailsIndex}
          trainingInfo={trainingInfo}
          trainingForedit={trainingForedit}
          branchesForedit={branchesForedit}
          trainingCertifications={trainingCertifications}
          branches={branches}
          showEducationTableInEditFlow={showEducationTableInEditFlow}
          showWorkTableInEditFlow={showWorkTableInEditFlow}
          editModeForEducationalDetails={editModeForEducationalDetails}
          editModeForWorkDetails={editModeForWorkDetails}
          handleEditEducationalInformation={handleEditEducationalInformation}
          addMoreEducationalInfo={addMoreEducationalInfo}
          handleEditWorkInformation={handleEditWorkInformation}
          addMoreWorkInfo={addMoreWorkInfo}
          showSaveEducationButton={showSaveEducationButton}
          showSaveWorkButton={showSaveWorkButton}
          addMoreRolesInfo={addMoreRolesInfo}
          // setAddMoreRolesInfo={setAddMoreRolesInfo}
          showSaveRolesButton={showSaveRolesButton}
          showSaveBranchesButton={showSaveBranchesButton}
          showSaveTrainingButton={showSaveTrainingButton}
          handelCancelRolesDetails={handelCancelRolesDetails}
          handelCancelTrainingDetails={handelCancelTrainingDetails}
          handelEditTrainingCertification={handelEditTrainingCertification}
          handelEditBranchesCertification={handelEditBranchesCertification}
          EditModeForTrainingCertification={EditModeForTrainingCertification}
          EditModeForBranchesCertification={EditModeForBranchesCertification}
          jsonForTrainingCertification={jsonForTrainingCertification}
          jsonForBranchesCertification={jsonForBranchesCertification}
          addMoreRoles={addMoreRoles}
          handleEditRolesInformation={handleEditWorkInformation}
          editModeForRolesDetails={editModeForRolesDetails}
          rolesDetailsIndex={rolesDetailsIndex}
          showRolesTableInEditFlow={showRolesTableInEditFlow}
          errors={errors}
          setIsSaveButtonClicked={setIsSaveButtonClicked}
          isSaveButtonCLicked={isSaveButtonCLicked}
          setErrors={setErrors}
        />
      </div>
      <div className=" hidden lg:block">
        <div>
          <div className="px-8 py-8">
            <div>
              {updatedJsonObj[order]?.name ===
                "Educational Information and Work Experience" && (
                <div>
                  <div className="flex justify-between ">
                    <div className="flex">
                      <EditIconWithColor />
                      <div className="pl-4 text-loginSubTitle font-poppins font-semibold">
                        {OnboardConstants.EducationalInformation}
                      </div>
                    </div>
                    <div className="flex">
                      {showSaveEducationButton && (
                        <div
                          className="ml-12 bg-primary px-4 text-whiteColor py-2 rounded-lg"
                          onClick={
                            addMoreEducationalInfo
                              ? handelCancelButtonForAddMoreEducationDetails
                              : handelCancelEducationalDetails
                          }
                        >
                          {"Cancel"}
                        </div>
                      )}
                      <div
                        className="ml-6 bg-primary text-whiteColor px-4 py-2 border border-primary rounded-lg"
                        onClick={
                          showSaveEducationButton
                            ? handelSaveEducationalDetails
                            : handelAddmoreEditEducationalDetails
                        }
                      >
                        {getButtonName(showSaveEducationButton)}
                      </div>
                    </div>
                  </div>
                  <EducationalDetailsTable
                    key={key}
                    userDetail={updatedJsonObj}
                    handleEditEducationalInformation={
                      handleEditEducationalInformation
                    }
                    editModeForEducationalDetails={
                      editModeForEducationalDetails
                    }
                    educationalDetailsIndex={educationalDetailsIndex}
                    order={order}
                    addMoreEducationalInfo={addMoreEducationalInfo}
                    setEditPayloadjson={setEditPayloadjson}
                    jsonForEditData={jsonForEditData}
                    isEditMode={true}
                    showEducationTableInEditFlow={showEducationTableInEditFlow}
                    setIsSaveButtonClicked={setIsSaveButtonClicked}
                    isSaveButtonCLicked={isSaveButtonCLicked}
                    errors={errors}
                    setErrors={setErrors}
                    educationalIndexRef={educationalIndexRef.current}
                    addMoreEducationEditRef={addMoreEducationEditRef.current}
                  />
                  <div className="flex justify-between pt-8">
                    <div className="flex">
                      <BriefcaseIconWithColor />
                      <div className="pl-4 text-loginSubTitle font-poppins font-semibold">
                        {OnboardConstants.WorkExperience}
                      </div>
                    </div>
                    <div className="flex">
                      {showSaveWorkButton && (
                        <div
                          className="ml-12 bg-primary px-4 text-whiteColor py-2 rounded-lg"
                          onClick={
                            showSaveWorkButton
                              ? handelCancelButtonForAddMoreWorkDetails
                              : handelCancelWorkDetails
                          }
                        >
                          {"Cancel"}
                        </div>
                      )}
                      <div
                        className="ml-6 bg-primary text-whiteColor px-4 py-2 border border-primary rounded-lg"
                        onClick={
                          showSaveWorkButton
                            ? handelSaveWorkDetails
                            : handelAddmoreEditWorkDetails
                        }
                      >
                        {getButtonName(showSaveWorkButton)}
                      </div>
                    </div>
                  </div>
                  <WorkExperienceTable
                    key={key}
                    userDetail={updatedJsonObj}
                    handleEditWorkInformation={handleEditWorkInformation}
                    editModeForWorkDetails={editModeForWorkDetails}
                    workDetailsIndex={workDetailsIndex}
                    order={order}
                    addMoreWorkInfo={addMoreWorkInfo}
                    setEditPayloadjson={setEditPayloadjson}
                    jsonForEditData={jsonForEditData}
                    isEditMode={true}
                    showWorkTableInEditFlow={showWorkTableInEditFlow}
                    errors={errors}
                    setIsSaveButtonClicked={setIsSaveButtonClicked}
                    isSaveButtonCLicked={isSaveButtonCLicked}
                    setErrors={setErrors}
                    workDetailsIndexRef={workDetailsIndexRef.current} 
                    addMoreWorkEditRef={addMoreWorkEditRef.current}
                    setIsWorkDetailsNull={setIsWorkDetailsNull}
                    isWorkDetailsNull={isWorkDetailsNull}
                  />
                  <div className="pt-8">
                    <div className="flex justify-between">
                      <div className="flex">
                        <BranchesIcon />
                        <div className="pl-4 text-loginSubTitle font-poppins font-semibold">
                          Training
                        </div>
                      </div>
                      <div className="flex">
                        {showSaveTrainingButton && (
                          <div
                            className="ml-12 bg-primary px-4 text-whiteColor py-2 rounded-lg"
                            onClick={handelCancelTrainingDetails}
                          >
                            {"Cancel"}
                          </div>
                        )}
                        <div
                          className="ml-6 bg-primary text-whiteColor px-4 py-2 border border-primary rounded-lg"
                          onClick={
                            showSaveTrainingButton
                              ? handelSaveTrainingDetails
                              : handelEditTrainingCertification
                          }
                        >
                          {getButtonLabel(
                            showSaveTrainingButton,
                            trainingCertifications
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {EditModeForTrainingCertification ? (
                    <div>
                      <PersonalInformationDynamic
                        // errorInfo={formError}
                        jsonobj={[jsonForTrainingCertification]}
                        order={0}
                        isEditMode={true}
                        setEditPayloadjson={setEditPayloadjson}
                      />
                    </div>
                  ) : (
                    <div className="fields grid grid-cols-1 md:grid-cols-3 gap-4 pt-6">
                      {updatedJsonObj[order]?.subSegments?.map(
                        (subSegment: SubSegment) => {
                          return subSegment?.attributes
                            .filter((attribute) => attribute.name !== "face") // Exclude "face" attributes
                            .map(
                              (attribute) =>
                                attribute.name === "trainingCertifications" && (
                                  <div
                                    className="pb-2"
                                    key={attribute.attributeId}
                                  >
                                    <TextFeild
                                      textFeildName={attribute?.label}
                                      placeholder={
                                        attribute.value?.length > 0
                                          ? attribute.value
                                              .map((item: any) => item.title)
                                              .join(", ") // Convert array to string
                                          : ""
                                      }
                                    />
                                  </div>
                                )
                            );
                        }
                      )}
                    </div>
                  )}
                </div>
              )}
              {updatedJsonObj[order]?.name ===
                "Roles, Applications and Permissions" && (
                <div>
                  <div className="flex justify-between">
                    <div className="flex">
                      <RolesAndPermissionIconWithColor />
                      <div className="pl-4 text-loginSubTitle font-poppins font-semibold">
                        {Constants.Roles}
                      </div>
                    </div>
                    <div className="flex">
                      {showSaveRolesButton && (
                        <div
                          className="ml-12 bg-primary px-4 text-whiteColor py-2 rounded-lg"
                          onClick={
                            showSaveRolesButton
                              ? handelCancelButtonForAddMoreRolesDetails
                              : handelCancelRolesDetails
                          }
                        >
                          {"Cancel"}
                        </div>
                      )}
                      <div
                        className="ml-6 bg-primary text-whiteColor px-2 py-1 border border-primary rounded-lg"
                        onClick={
                          showSaveRolesButton
                            ? handelSaveRolesDetails
                            : handelAddmoreEditRolesDetails
                        }
                      >
                        {getButtonName(showSaveRolesButton)}
                      </div>
                    </div>
                  </div>
                  <RolesAndPermissionTable
                    userDetail={updatedJsonObj}
                    handleEditRolesInformation={handleEditWorkInformation}
                    editModeForRolesDetails={editModeForRolesDetails}
                    rolesDetailsIndex={rolesDetailsIndex}
                    order={order}
                    addMoreRolesInfo={addMoreRolesInfo}
                    setEditPayloadjson={setEditPayloadjson}
                    jsonForEditData={jsonForEditData}
                    isEditMode={true}
                    showRolesTableInEditFlow={showRolesTableInEditFlow}
                    addMoreRoles={addMoreRoles}
                    errors={errors}
                    setIsSaveButtonClicked={setIsSaveButtonClicked}
                    isSaveButtonCLicked={isSaveButtonCLicked}
                    setErrors={setErrors}
                    setIsSpecilizationManditory={setIsSpecilizationManditory}
                    handleDeleteButtonChangeForEditFlow={handleDeleteButtonChangeForEditFlow}
                    isDeletingRef={isDeletingRef}
                    setSelectedSpecializationList={setSelectedSpecializationList}
      selectedSpecializationList={selectedSpecializationList}
                  />
                  <div className="flex justify-between pt-8">
                    <div className="flex">
                      <BranchesIcon />
                      <div className="pl-4 text-loginSubTitle font-poppins font-semibold">
                        {"Branches"}
                      </div>
                    </div>
                    <div className="flex">
                      {showSaveBranchesButton && (
                        <div
                          className="ml-12 bg-primary px-4 text-whiteColor py-2 rounded-lg"
                          onClick={handelCancelBranchesDetails}
                        >
                          {"Cancel"}
                        </div>
                      )}
                      <div
                        className="ml-6 bg-primary text-whiteColor px-2 py-1 border border-primary rounded-lg"
                        onClick={
                          showSaveBranchesButton
                            ? handelSaveBranchesDetails
                            : handelEditBranchesCertification
                        }
                      >
                        {getButtonLabel(showSaveBranchesButton, branches)}
                      </div>
                    </div>
                  </div>
                  {EditModeForBranchesCertification ? (
                    <div>
                      <PersonalInformationDynamic
                        jsonobj={[jsonForBranchesCertification]}
                        order={0}
                        isEditMode={true}
                        setEditPayloadjson={setEditPayloadjson}
                        setIsBranchesManditory={setIsBranchesManditory}
                        errors={errors}
                        
                      />
                    </div>
                  ) : (
                    <div className="fields grid grid-cols-1 md:grid-cols-3 gap-4 pt-8">
                      {updatedJsonObj[order]?.subSegments?.map(
                        (subSegment: SubSegment) => {
                          return subSegment.attributes
                            .filter((attribute) => attribute.name !== "face") // Exclude "face" attributes
                            .map(
                              (attribute) =>
                                attribute?.name === "branches" && (
                                  <div
                                    className="pb-2"
                                    key={attribute?.attributeId}
                                  >
                                    <TextFeild
                                      textFeildName={attribute?.label}
                                      placeholder={
                                        attribute?.value?.length > 0
                                          ? attribute?.value
                                              .map((branch: any) => branch?.name)
                                              .join(", ") // Join names with commas
                                          : ""
                                      }
                                    />
                                  </div>
                                )
                            );
                        }
                      )}
                    </div>
                  )}
                </div>
              )}

              {/*     
          {/* Default case: Render TextField for other attributes except "face" */}
              <div className="fields grid grid-cols-1 md:grid-cols-3 gap-4">
                {updatedJsonObj[order]?.subSegments?.map(
                  (subSegment: SubSegment) => {
                    <div>{subSegment.name}</div>;
                    return subSegment.attributes.map(
                      (attribute) =>
                        updatedJsonObj[order]?.name !==
                          "Educational Information and Work Experience" &&
                        updatedJsonObj[order]?.name !==
                          "Roles, Applications and Permissions" && (
                          <div className="pb-2" key={attribute.attributeId}>
                            <TextFeild
                              textFeildName={attribute.label}
                              placeholder={
                                updatedJsonObj[order]?.name ===
                                "Bank account details"
                                  ? maskBankValue( attribute?.value === null ? "" : attribute.value)
                                  : attribute.value
                                  ? String(attribute.value)
                                  : ""
                              }
                            />
                          </div>
                        )
                    );
                  }
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
